import React, {useContext} from "react";
import PositionedMenu from "./PositionedMenu";
import MenuItem from "./MenuItem";
import useCurrentShortcut from "../hooks/useCurrentShortcut";
import {BrandContext} from "./BrandContext";

const ListItemTrail = props => {
    const {trail, user, actionOnClick} = props;
    const {loadShortcutByUrl} = useCurrentShortcut();
    const brandConfig = useContext(BrandContext);

    const editTrailFromDashboard = () => {
        globalReactFunctions.editTrailFromDashboard = true;
        globalReactFunctions.pathwayId = trail.pathwayId;
        loadShortcutByUrl('/web/ui/view/teacherTrails');
    }

    const createTrailAssignmentFromDashboard = () => {
        globalReactFunctions.assignTrailFromDashboard = true;
        globalReactFunctions.pathwayId = trail.pathwayId;
        loadShortcutByUrl('/web/ui/view/teacherTrails');
    }

    const shareTrailFromDashboard = () => {
        globalReactFunctions.shareTrailFromDashboard = true;
        globalReactFunctions.pathwayId = trail.pathwayId;
        loadShortcutByUrl('/web/ui/view/teacherTrails');
    }

    const copyTrailFromDashboard = () => {
        globalReactFunctions.copyTrailFromDashboard = true;
        globalReactFunctions.pathwayId = trail.pathwayId;
        loadShortcutByUrl('/web/ui/view/teacherTrails');
    }

    return (
        <div className={'ch-dashboard-item-blk'}>
            <div className={'ch-dashboard-item-column-main'}>
                <div className={'ch-dashboard-item-title'}>{trail.pathwayName}</div>
                <div>
                    Created on: {user.dateFormat.format(trail.createDate)}
                    {trail.assignedDate != null &&
                        <span>, Assigned on: {user.dateFormat.format(trail.assignedDate)}</span>
                    }
                </div>
            </div>
            <div>
                <PositionedMenu label={brandConfig.taskName + ' action menu'}>
                    <MenuItem onClick={editTrailFromDashboard} label="Edit">Edit</MenuItem>
                    {trail.valid &&
                        <MenuItem onClick={createTrailAssignmentFromDashboard} label="Assign">Assign</MenuItem>
                    }
                    <MenuItem onClick={shareTrailFromDashboard} label="Share">Share</MenuItem>
                    <MenuItem onClick={copyTrailFromDashboard} label="Copy">Copy</MenuItem>
                </PositionedMenu>
            </div>
        </div>
    )
}

export default ListItemTrail;